var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"trust1-danger"},_vm._l((_vm.messages),function(m){return _c('div',{key:m},[_vm._v(_vm._s(m))])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }